import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  InitializeAddProcessesContract,
  InitializeAddProcessesRequest,
  InitializeAddProcessesResponse
} from '@bliks-io/contracts';
import { apiClient } from '../client';
import { invalidateEntity } from '../cache-invalidation';
import { organizationKeys } from '../query-keys';

export function useInitializeProcesses() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: InitializeAddProcessesRequest) => {
      const { data: response } = await apiClient.post<InitializeAddProcessesResponse>(
        InitializeAddProcessesContract.path,
        data
      );
      return response;
    },
    onSuccess: () =>
      // Awaited (returned) on purpose — see useInitializeSystems.
      Promise.all([
        invalidateEntity(queryClient, 'process'),
        // First import stamps initialization.processes on the organization.
        queryClient.invalidateQueries({ queryKey: organizationKeys.all })
      ])
  });
}
